import { jsPDF } from 'jspdf';

import { formatDate } from './formatDate';

const feSaudeLogo = new Image();
feSaudeLogo.src = '../assets/img/fesaude-logo.png';
feSaudeLogo.alt = 'FeSaúde Logo';

const niteroiLogo = new Image();
niteroiLogo.src = '../assets/img/niteroi-logo.jpeg';
niteroiLogo.alt = 'Niterói Logo';

const pdfAlteracaoFerias = data => {
  const doc = new jsPDF('p', 'mm', 'a4');
  const pageWidth = doc.internal.pageSize.width || doc.internal.pageSize.getWidth();
  const leftMargin = 15;
  const center = pageWidth / 2;
  let line = 0;
  const step = 10;

  doc.setProperties({
    title: 'FORMULÁRIO DE ALTERAÇÃO DE MARCAÇÃO DE FÉRIAS DO EMPREGADO'
  });

  doc.addImage(niteroiLogo, 'JPEG', 15, 15, 29, 9);
  doc.addImage(feSaudeLogo, 'PNG', pageWidth - 30, 10, 16, 17);

  doc.setFontSize(12);
  doc.setFont(undefined, 'bold');
  doc.text(
    'FORMULÁRIO DE ALTERAÇÃO DE MARCAÇÃO DE FÉRIAS DO EMPREGADO',
    center,
    line += (step * 4),
    { align: 'center' }
  );

  doc.setFontSize(10);
  doc.setFont(undefined, 'normal');
  doc.text(
    'À Gerência de Gestão de Pessoas,',
    leftMargin,
    line += step + 5,
    { align: 'left' }
  );

  doc.text(
    'Eu, _______________________________________________________________________________________,',
    leftMargin,
    line += step + 5,
    { align: 'left' }
  );

  doc.text(
    data.nome,
    leftMargin + 8,
    line,
    { align: 'left' }
  );

  doc.text(
    'cargo, _____________________________________________________________________________________,',
    leftMargin,
    line += step,
    { align: 'left' }
  );

  doc.text(
    data.cargo,
    leftMargin + 13,
    line,
    { align: 'left' }
  );

  doc.text(
    'matrícula, ________________, solicito a alteração da marcação de minhas férias, referente ao período aquisitivo',
    leftMargin,
    line += step,
    { align: 'left' }
  );

  doc.text(
    data.matricula,
    leftMargin + 19,
    line,
    { align: 'left' }
  );

  doc.text(
    `de ${data.exercicioDe} a ${data.exercicioA}, solicitadas para início em ${formatDate(data.feriasAnteriorDe)} e término em ${formatDate(data.feriasAnteriorA)}, para o período de`,
    leftMargin,
    line += step,
    { align: 'left' }
  );

  doc.text(
    `${formatDate(data.alteracaoGozoInicio1)} a ${formatDate(data.alteracaoGozoFim1)}, nos mesmos termos da solicitação anterior.`,
    leftMargin,
    line += step,
    { align: 'left' }
  );

  doc.text(
    'Com a ciência e devida autorização da Diretoria.',
    leftMargin,
    line += step + 10,
    { align: 'left' }
  );

  doc.text(
    'Assinatura do empregado: ___________________________________________________',
    leftMargin,
    line += step + 10,
    { align: 'left' }
  );

  doc.text(
    '____________________________________________________________\nAutorização da Chefia Imediata (Carimbo e Rubrica)',
    center,
    line += step + 10,
    { align: 'center' }
  );

  doc.text(
    'Data _____/_____/_____',
    leftMargin,
    line += step + 10,
    { align: 'left' }
  );

  doc.setFontSize(8);
  doc.text(
    `
Fundação Estatal de Saúde de Niterói – FeSaúde
Endereço: Rua Visconde do Uruguai, 531 – sala 203 – Centro – Niterói – RJ – CEP: 24030-076
Telefone: 2714-6579 / CNPJ: 34.906.284/0001-00
`,
    center,
    275,
    { align: 'center' }
  );

  window.open(URL.createObjectURL(doc.output(
    'blob',
    {
      filename: `marcacao-ferias-${data.nome}-${data.matricula}`
    }
  )));
};

export default pdfAlteracaoFerias;
